import { gql, TypedDocumentNode } from "@apollo/client";

import type { CareerPlanStatus, CreateCareerPlanInput, UpdateCareerPlanInput } from "./careerPlanDocument";
import { CAREER_PLAN_DOCUMENT_FIELDS, type CareerPlanDocument } from "./queries";

export type CareerPlanMutationResult = {
  success: boolean;
  message: string | null;
  careerPlan: CareerPlanDocument | null;
  task?: { id: string } | null;
  taskError?: string | null;
};

export type CreateCareerPlanResponse = {
  createCareerPlan: CareerPlanMutationResult;
};

export type CreateCareerPlanVariables = {
  input: CreateCareerPlanInput;
};

export type UpdateCareerPlanResponse = {
  updateCareerPlan: CareerPlanMutationResult;
};

export type UpdateCareerPlanVariables = {
  input: UpdateCareerPlanInput;
};

export type UpdateCareerPlanStatusResponse = {
  updateCareerPlanStatus: CareerPlanMutationResult;
};

export type UpdateCareerPlanStatusVariables = {
  id: string;
  status: CareerPlanStatus;
};

export const CREATE_CAREER_PLAN_MUTATION: TypedDocumentNode<CreateCareerPlanResponse, CreateCareerPlanVariables> = gql`
  mutation CreateCareerPlan($input: BackofficeCreateCareerPlanInput!) {
    createCareerPlan(input: $input) {
      success
      message
      careerPlan {
        ...CareerPlanDocumentFields
      }
      task {
        id
      }
      taskError
    }
  }
  ${CAREER_PLAN_DOCUMENT_FIELDS}
`;

export const UPDATE_CAREER_PLAN_MUTATION: TypedDocumentNode<UpdateCareerPlanResponse, UpdateCareerPlanVariables> = gql`
  mutation UpdateCareerPlan($input: BackofficeUpdateCareerPlanInput!) {
    updateCareerPlan(input: $input) {
      success
      message
      careerPlan {
        ...CareerPlanDocumentFields
      }
      task {
        id
      }
      taskError
    }
  }
  ${CAREER_PLAN_DOCUMENT_FIELDS}
`;

export const UPDATE_CAREER_PLAN_STATUS_MUTATION: TypedDocumentNode<
  UpdateCareerPlanStatusResponse,
  UpdateCareerPlanStatusVariables
> = gql`
  mutation UpdateCareerPlanStatus($id: ID!, $status: BackofficeCareerPlanStatus!) {
    updateCareerPlanStatus(id: $id, status: $status) {
      success
      message
      careerPlan {
        ...CareerPlanDocumentFields
      }
    }
  }
  ${CAREER_PLAN_DOCUMENT_FIELDS}
`;
